module.exports = __webpack_public_path__ + "03_mole.ab490d3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer3/03_mole.png
// module id = zYAp
// module chunks = 0